(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    reveal() {}
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  if (!customElements.get('collection-description-toggle')) {
    customElements.define('collection-description-toggle', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button) return;
        this.resetState();

        if (this.dataset.toggleReady === 'true') return;
        this.dataset.toggleReady = 'true';

        button.addEventListener('click', () => {
          const expanded = this.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? button.dataset.readLess : button.dataset.readMore;
        });
      }

      resetState() {
        const button = this.querySelector('button');
        if (!button) return;
        this.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = button.dataset.readMore;
      }
    });
  }

  if (!window.collectionDescriptionPageshowBound) {
    window.collectionDescriptionPageshowBound = true;
    window.addEventListener('pageshow', () => {
      document.querySelectorAll('collection-description-toggle').forEach((toggle) => {
        toggle.resetState();
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('collection-infinite-scroll')) {
    customElements.define('collection-infinite-scroll', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('#product-grid');
        this.pagination = this.querySelector('.collection-infinite-scroll__pagination');
        this.sentinel = this.querySelector('.collection-infinite-scroll__sentinel');
        if (!this.grid || !this.pagination || !this.sentinel) return;

        this.initialCount = Number(this.dataset.initialCount) || 16;
        this.stepCount = Number(this.dataset.stepCount) || 8;
        this.fetchPromise = null;
        this.nextUrl = this.getNextUrl(this.pagination);

        Array.from(this.grid.children).forEach((item, index) => {
          if (index >= this.initialCount) item.hidden = true;
        });

        if (!this.nextUrl && !this.getHiddenItems().length) {
          this.classList.add('is-complete');
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this.sentinel);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      getHiddenItems() {
        return Array.from(this.grid.children).filter((item) => item.hidden);
      }

      getNextUrl(container) {
        const link = container.querySelector('a.pagination__item--prev');
        return link ? link.href : '';
      }

      async loadMore() {
        let hiddenItems = this.getHiddenItems();
        if (!hiddenItems.length && this.nextUrl) {
          await this.fetchNextPage();
          hiddenItems = this.getHiddenItems();
        }

        hiddenItems.slice(0, this.stepCount).forEach((item) => {
          item.hidden = false;
        });

        const remainingItems = this.getHiddenItems();
        if (remainingItems.length <= this.stepCount && this.nextUrl) this.fetchNextPage();
        if (!remainingItems.length && !this.nextUrl) this.classList.add('is-complete');

        window.setTimeout(() => {
          if (this.sentinel.getBoundingClientRect().top < window.innerHeight + 600) this.loadMore();
        }, 150);
      }

      async fetchNextPage() {
        if (this.fetchPromise || !this.nextUrl) return this.fetchPromise;

        const url = new URL(this.nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.grid.dataset.id);
        this.classList.add('is-loading');
        this.fetchPromise = fetch(url.toString())
          .then((response) => {
            if (!response.ok) throw new Error(String(response.status));
            return response.text();
          })
          .then((html) => {
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            const nextScroller = documentFragment.querySelector('collection-infinite-scroll');
            if (!nextScroller) {
              this.nextUrl = '';
              return;
            }

            nextScroller.querySelectorAll('#product-grid > .grid__item').forEach((item) => {
              item.hidden = true;
              this.grid.appendChild(document.importNode(item, true));
            });

            const nextPagination = nextScroller.querySelector('.collection-infinite-scroll__pagination');
            this.nextUrl = nextPagination ? this.getNextUrl(nextPagination) : '';
            this.pagination.innerHTML = nextPagination ? nextPagination.innerHTML : '';
          })
          .catch(() => {
            this.pagination.style.display = 'block';
            this.nextUrl = '';
          })
          .finally(() => {
            this.classList.remove('is-loading');
            this.fetchPromise = null;
          });

        return this.fetchPromise;
      }
    });
  }

  if (!customElements.get('collection-seo-description')) {
    customElements.define('collection-seo-description', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button) return;

        this.resetState();
        if (this.dataset.toggleReady === 'true') return;
        this.dataset.toggleReady = 'true';

        button.addEventListener('click', () => {
          const expanded = this.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? button.dataset.readLess : button.dataset.readMore;
        });
      }

      resetState() {
        const button = this.querySelector('button');
        if (!button) return;
        this.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = button.dataset.readMore;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["organic-premium-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('organic-card-story')) {
  customElements.define('organic-card-story', class extends HTMLElement {
    connectedCallback() {
      this.previewView = new URL(window.location.href).searchParams.get('view');
      this.onClick = (event) => {
        const link = event.target.closest('[data-organic-variant]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const picker = document.querySelector(`variant-radios[data-section="${this.dataset.mainId}"]`);
        const input = Array.from(picker?.querySelectorAll('input[type="radio"]') || []).find(item => item.value === link.dataset.optionValue);
        if (!input) return;
        event.preventDefault();
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        const target = document.getElementById(`ProductInfo-${this.dataset.mainId}`);
        target?.scrollIntoView({ behavior: 'auto', block: 'start' });
        const label = picker.querySelector(`label[for="${input.id}"]`);
        if (label) { label.setAttribute('tabindex', '-1'); label.focus({ preventScroll: true }); }
      };
      this.onVariant = (event) => {
        if (this.previewView) {
          const url = new URL(window.location.href);
          url.searchParams.set('view', this.previewView);
          window.history.replaceState({}, '', url);
        }
        this.querySelectorAll('[data-organic-variant]').forEach(link => {
          if (link.dataset.organicVariant === String(event.detail?.id)) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };
      this.addEventListener('click', this.onClick);
      window.addEventListener('safir:variant-change', this.onVariant);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('safir:variant-change', this.onVariant);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safir-belts-story"] && !Shopify.designMode) return;
  try {
    
  const beltStory = document.querySelector('.safir-belts-story');
  const beltStorySection = beltStory?.closest('.shopify-section');
  const beltGridDescription = beltStorySection?.previousElementSibling?.querySelector('.collection-seo-description');
  if (beltGridDescription) beltGridDescription.hidden = true;

  } catch(e) { console.error(e); }
})();
})();
